import $ from 'jquery';
// slick is loaded from the CDN in _Layout <head> and registers on the global jQuery (which the bundle
// also uses via webpack externals) — bundling a second copy added 87KB for nothing.

export default function initProductCollectionCarousel(){
    $('.product-collection-carousel').slick({
        dots: true,
        infinite: true,
        speed: 300,
        autoplay: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });
}
